<div
  class="container"
  [ngClass]="appStyle() + '-mode'"
  [style.height.px]="containerHeight()"
>
  <div class="title">
    {{ data().title }}
    @if (data().subtitle) {
      <span class="subtitle">{{ data().subtitle }}</span>
    }
  </div>

  <div class="legend">
    @for (legend of data().legendItems; track legend) {
      <span
        class="legend-item"
        [ngClass]="{ ipt: appStyle() === 'ipt', pp: appStyle() === 'pp' }"
      >
        @if (appStyle() === 'default') {
          <i class="material-symbols-rounded" [style.color]="legend.color">
            circle
          </i>
        } @else {
          <div class="bar-icon" [style.background-color]="legend.color"></div>
        }
        {{ legend.name }}
      </span>
    }
  </div>

  <div class="items">
    @for (item of items(); track item) {
      <div
        class="item-container"
        [style.width.px]="
          data().itemsWithEqualSize || itemsWithEqualSize()
            ? largestItemWidth()
            : null
        "
      >
        <div class="bar-container">
          @if (isItemEmpty(item) && item.bars.length > 2) {
            <div
              class="progress-bar-compact-placeholder"
              [style.background-color]="
                data().colors?.empty ?? defaultColors.empty
              "
            ></div>
          } @else {
            @for (bar of item.bars; track bar) {
              <div
                class="progress-bar"
                [style.height.px]="getBarHeightInPixels(bar)"
                [style.background-color]="
                  bar.heightPercentage
                    ? (data().colors?.unfilled ?? defaultColors.unfilled)
                    : (data().colors?.empty ?? defaultColors.empty)
                "
                poziOverlay
                [template]="
                  !isBarEmpty(bar) && bar.tooltip ? tooltipTemplate : undefined
                "
                [templateContext]="{ date: item.date, tooltip: bar.tooltip }"
                [cdkOverlayPositionPairs]="cdkOverlayPositionPairs"
              >
                @if (bar.filledPercentage) {
                  <div
                    class="inner-progress-bar"
                    [style.height.%]="bar.filledPercentage"
                    [style.background-color]="getBarColor(bar)"
                  ></div>
                }
              </div>
            }
          }
        </div>
        <span
          class="date-label"
          [style.color]="
            item.labelColor || (isItemEmpty(item) ? '#8CA0B4' : 'inherit')
          "
          >{{ getDisplayedLabel(item) }}</span
        >
      </div>
    }
    @if (yAxis()) {
      <div class="item-container y-axis">
        <div class="y-axis-track" [style.height.px]="maxBarHeightInPixels()">
          <span class="y-axis-label">{{ yAxisTopHours() }}h</span>
          <span class="y-axis-label">{{ yAxisMiddleHours() }}h</span>
          <span class="y-axis-label">0h</span>
        </div>
        <span class="date-label">&nbsp;</span>
      </div>
    }
  </div>
</div>

<ng-template #tooltipTemplate let-date="date" let-tooltip="tooltip">
  <div class="tooltip" [class.tooltip-block]="tooltip && tooltip.length">
    @for (value of tooltip; track value) {
      <div
        class="text"
        [style.color]="value.color || '#14181c'"
        [class.bold]="value.bold"
      >
        @if (value.hasOwnProperty('text')) {
          {{ value.text }}
        } @else if (value.hasOwnProperty('date')) {
          {{ date | formatDate: value.dateFormat }}
        }
      </div>
    }
  </div>
</ng-template>
